module.exports = __webpack_public_path__ + "static/img/sh.be61c69d.png";